namespace SolovisGateway.Admin.DataEnvironments {

  /**
   * AdminEnvironmentListControl presents the user interface for administratinge environments
   * This is *NOT* the same as the list for the "Environments" section list which we purposely keep separate
   * which lets people do things like add users to environments.
   */
  export class AdminEnvironmentListControl extends Solovis.UI.BaseControl {

    private _envList;
    private _initError;

    private _toolbarContainer;
    private _toolbar: Solovis.UI.Toolbar;

    private _dataGrid: DevExpress.ui.dxDataGrid;

    constructor(options) {
      super(options);
    }

    public doInitAsync() {
      let self = this;

      Solovis.Rpc.invokeAndWait(
        "~/Admin/DataEnvironmentAdmin/GetDataEnvironments",
        {},
        function (response, success) {
          if (success) {
            self._envList = response.result.dataEnvironments;
          }
          else {
            console.log("ERROR: AdminEnvironmentListControl.doInitAsync");
            console.log(response.error);
            self._initError = response.error;
          }

          self.notifyInitComplete();
        });
    }

    public doRender() {
      let self = this;

      this._toolbarContainer = $("<div>").appendTo(this.container);

      var toolbar = new Solovis.UI.Toolbar({
        container: this._toolbarContainer
      });
      this._toolbar = toolbar;

      toolbar.addItem({
        name: "addDataEnvironmentButton",
        createToolbarItem: function () {
          var addDataEnvironmentButton = new Solovis.UI.Buttons.Button({
            element: $("<div>").text("Add Data Environment").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-plus")),
            size: "small",
            click: function () {
              self._showAddDataEnvironmentInterface({
                saveCallback: function () {
                  self._refreshEnvironments();
                }
              });
            }
          });

          return addDataEnvironmentButton;
        }
      });

      toolbar.addItem({
        name: "userDataManagementButton",
        createToolbarItem: function () {
          return new Solovis.UI.Buttons.Button({
            element: $("<div>")
              .text("User Data Environment Upload")
              .prepend($("<span>")
                .css("padding-right", "5px")
                .addClass("fa fa-users")),
            size: "small",
            click: function () {
              location.href = Solovis.resolveUrl("~/Admin/UserAdmin/UploadUserPermissions");
            }
          });
        }
      });

      // Setup data grid
      let dataGridContainer = $("<div>").appendTo(this.container);

      let store = new DevExpress.data.ArrayStore({
        key: 'id',
        data: this._envList
      });

      dataGridContainer.dxDataGrid({
        dataSource: {
          store: store,
          sort: 'subdomain'
        },

        columnResizingMode: 'widget',
        allowColumnResizing: true,
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        searchPanel: { visible: true },
        grouping: { contextMenuEnabled: true },
        columnChooser: { enabled: true },
        filterRow: {
          visible: true
        },
        export: {
          enabled: true
        },

        width: "100%",

        columns: [
          {
            caption: "Actions",
            allowSorting: false,
            cellTemplate: function (container, options) {
              let envData = options.data;
              self._buildActionsCell(container, envData);
            },
            width: 75
          },
          {
            dataField: 'subdomain',
            dataType: 'string',
            caption: 'Subdomain',
            allowSorting: true,
            width: 200,
            cellTemplate: function (container, options) {
              let envData = options.data;
              let envLink = $("<a>").text(envData.subdomain).attr("href", envData.url);
              envLink.appendTo(container);
            }
          },
          {
            dataField: 'description',
            dataType: 'string',
            caption: 'Description',
            allowSorting: true,
            width: 200
          },
          {
            dataField: 'id',
            dataType: 'number',
            caption: 'Data Environment Id',
            visible: false,
            allowSorting: true,
            width: 150
          },
          {
            dataField: 'organizationId',
            dataType: 'number',
            caption: 'Organization Id',
            visible: false,
            allowSorting: true,
            width: 150
          },
          {
            dataField: 'organizationName',
            dataType: 'string',
            caption: 'Organization',
            visible: true,
            allowSorting: true,
            width: 150
          },
          {
            dataField: 'organizationCode',
            dataType: 'string',
            caption: 'Organization Code',
            visible: false,
            allowSorting: true,
            width: 150
          },
          {
            dataField: 'environmentPoolId',
            dataType: 'number',
            caption: 'Environment Pool Id',
            visible: false,
            allowSorting: true,
            width: 150
          },
          {
            dataField: 'environmentPoolName',
            dataType: 'string',
            caption: 'Pool',
            visible: true,
            allowSorting: true,
            width: 150
          },
        ]
      });

      this._dataGrid = dataGridContainer.dxDataGrid("instance");
    }

    private _showAddDataEnvironmentInterface(options) {
      // TODO: Convert to strong reference once everything is TypeScript.
      (SolovisGateway as any).Admin.DataEnvironments.AddDataEnvironmentEditorDialog.showDialog(options);
    }


    private _buildActionsCell(container, envData) {
      let self = this;
      let columnDiv = container;

      let editEnvLink = $("<a>").appendTo(columnDiv);;
      $("<span class='fa fa-pencil'>").appendTo(editEnvLink);
      editEnvLink.attr("title", "Edit Data Environment");
      editEnvLink.attr(
        "href",
        Solovis.resolveUrl("~/Admin/DataEnvironmentAdmin/Info/" + envData.id));

      let manageUsersLink = $("<a>").css("padding-left", "5px").appendTo(columnDiv);
      $("<span class='fa fa-user'>").appendTo(manageUsersLink);
      manageUsersLink.attr("title", "Manage Users");
      manageUsersLink.attr(
        "href",
        Solovis.resolveUrl("~/DataEnvironment/ManageUsers?dataEnvironmentId=" + envData.id));
    }


    private _refreshEnvironments() {
      let self = this;

      Solovis.Rpc.invokeAndWait(
        "~/Admin/DataEnvironmentAdmin/GetDataEnvironments",
        {},
        function (response, success) {
          if (success) {
            let environments = response.result.dataEnvironments;
            let store = new DevExpress.data.ArrayStore({ key: 'id', data: environments });

            self._dataGrid.option("dataSource", store);
          }
        });
    }
  }
}